// @ts-nocheck
import React from "react";
import { Draggable } from "@hello-pangea/dnd";

// Font awesome
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from "@fortawesome/free-solid-svg-icons";

import "./ImagesItems.css";
import { t } from "i18next";

export default function ImagesItems(props) {
	if (!props.images || !props.images?.length)
	{
		return (
			<div className="image-items-placeholder">
				{t("Commons.DROP")}
			</div>
		);
	}
	return (
		props.images.map((img, index) => {
			let dragId = img.documentId;
			if (img.isDeleted)
				return (false);
			if (img.tempId)
				dragId = img.tempId;
			return (
				<DraggableImageItem
					img={img}
					handleDelete={props.handleDelete}
					index={index}
					key={dragId}
					onClick={props.onClick}
					{...props}
				/>
			);
		})
	);
}

function DraggableImageItem(props) {
	const {img, index, onClick, handleDelete} = props;

	function handleClick() {
		if (onClick)
			onClick(img);
	}

	let dragId = String(img.documentId);
	if (img.tempId)
		dragId = String(img.tempId);

	let bg_img = img.urlMin;
	if (img.documentFile)
	{
		if (img.documentFile.indexOf("data:image") === -1)
			bg_img = "data:image/png;base64," + img.documentFile;
		else
			bg_img = img.documentFile;
	}

	return (
		<Draggable
			draggableId={dragId} index={index}
			isDragDisabled={props.isDragDisabled}
		>
			{(provided) => {
				return (
					<div
						onClick={handleClick}
						ref={provided?.innerRef}
						{...provided?.draggableProps}
						{...provided?.dragHandleProps}
					>
						<div className="image-preview" style={{backgroundImage: "url(" + bg_img + ")"}}>
							{
								handleDelete &&
									<div
										className="del-image-btn"
										title={t("Images.RM_IMAGE")}
										onClick={(e) => {
											e.preventDefault(); e.stopPropagation(); handleDelete(img);
										}}
									>
										<FontAwesomeIcon icon={faTimes}/>
									</div>
							}
						</div>
					</div>
				);
			}}
		</Draggable>
	);
}
